import { defineComponent as s, openBlock as a, createElementBlock as o, mergeProps as d, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as p } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const M = { key: 0 }, g = { key: 1 }, f = { key: 2 }, h = { key: 3 }, k = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconDotsThreeOutline"
}, v = /* @__PURE__ */ s({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(A) {
    const Z = A, { bind: m, weight: l } = u(Z);
    return (r, t) => (a(), o("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(m)), [
      i(r.$slots, "default"),
      e(l) === "bold" ? (a(), o("g", M, t[0] || (t[0] = [
        n("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,40a8,8,0,1,1,8-8A8,8,0,0,1,128,136Zm80-40a32,32,0,1,0,32,32A32,32,0,0,0,208,96Zm0,40a8,8,0,1,1,8-8A8,8,0,0,1,208,136ZM48,96a32,32,0,1,0,32,32A32,32,0,0,0,48,96Zm0,40a8,8,0,1,1,8-8A8,8,0,0,1,48,136Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (a(), o("g", g, t[1] || (t[1] = [
        n("path", {
          d: "M152,128a24,24,0,1,1-24-24A24,24,0,0,1,152,128ZM48,104a24,24,0,1,0,24,24A24,24,0,0,0,48,104Zm160,0a24,24,0,1,0,24,24A24,24,0,0,0,208,104Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144ZM48,96a32,32,0,1,0,32,32A32,32,0,0,0,48,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,48,144ZM208,96a32,32,0,1,0,32,32A32,32,0,0,0,208,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,208,144Z" }, null, -1)
      ]))) : e(l) === "fill" ? (a(), o("g", f, t[2] || (t[2] = [
        n("path", { d: "M156,128a28,28,0,1,1-28-28A28,28,0,0,1,156,128ZM48,100a28,28,0,1,0,28,28A28,28,0,0,0,48,100Zm160,0a28,28,0,1,0,28,28A28,28,0,0,0,208,100Z" }, null, -1)
      ]))) : e(l) === "light" ? (a(), o("g", h, t[3] || (t[3] = [
        n("path", { d: "M128,98a30,30,0,1,0,30,30A30,30,0,0,0,128,98Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,128,146ZM48,98a30,30,0,1,0,30,30A30,30,0,0,0,48,98Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,48,146ZM208,98a30,30,0,1,0,30,30A30,30,0,0,0,208,98Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,208,146Z" }, null, -1)
      ]))) : e(l) === "regular" ? (a(), o("g", k, t[4] || (t[4] = [
        n("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144ZM48,96a32,32,0,1,0,32,32A32,32,0,0,0,48,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,48,144ZM208,96a32,32,0,1,0,32,32A32,32,0,0,0,208,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,208,144Z" }, null, -1)
      ]))) : e(l) === "thin" ? (a(), o("g", w, t[5] || (t[5] = [
        n("path", { d: "M128,100a28,28,0,1,0,28,28A28,28,0,0,0,128,100Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,128,148ZM48,100a28,28,0,1,0,28,28A28,28,0,0,0,48,100Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,48,148Zm160-48a28,28,0,1,0,28,28A28,28,0,0,0,208,100Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,208,148Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  v as default
};
